import React from 'react'
import { useArticuloBimLink } from 'context/ArticuloBimLinkContext'

const LastUser = () => {
  const { ultimaVezPor, userId } = useArticuloBimLink()

  return (
    <div className="new-bimlink-input">
      <label className="new-bimlink-label">
        Modificado última vez por:{' '}
        <label className="nameUser-label">({userId})</label>
      </label>
      <label className="new-bimlink-label">
        Modificado última vez{' '}
        <label className="nameUser-label">({ultimaVezPor})</label>
      </label>
    </div>
  )
}

export default LastUser
